import type { NavigationGuard } from 'vue-router';
import { useAuthStore } from './../stores/auth-store';

export const adminPageGuard: NavigationGuard = async (to) => {
   const authStore = useAuthStore();

   if (to.path === '/admin' && !(authStore.userProfile?.org_id === 'NMED' && authStore.userProfile?.org_user_role === 'ADMIN')) {
      return '/';
   }
};
